module.exports = __webpack_public_path__ + "media/images/credit-card-payment-dbb287a4076601d4bca5e01ef5f7cfce.svg";